<template>
  <div class="header-tool flex row-center">
    <div class="header-content">
      <div>
        <span v-if="!isLogin">您好，欢迎来到登录平台</span>
        <template v-else>
          <button class="primary-button" @click="back">返回</button>
        </template>
      </div>
      <div class="header-content-right">
        <div class="flex row-center">
          <img class="icon" src="../../assets/images/common/icon-earphone.png" alt="" />
          客服电话：{{ consumerHotline }}
        </div>
        <div class="wechat flex-center">
          <img class="icon" src="../../assets/images/common/icon-wechat.png" alt="" />
          微信公众号
          <div class="wechat-code">
            <img src="../../assets/images/common/wechat-qr.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HeaderTool',

  computed: {
    ...mapState('system', ['consumerHotline']),
    ...mapState('user', ['isLogin', 'loginIdentity', 'employeeName']),

    returnUrl() {
      return this.$route.query.returnUrl
    }
  },

  methods: {
    back() {
      window.location.href =
        this.returnUrl || `${process.env.VUE_APP_LOGIN_JUMP_URL}`
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: pixel-to-rem($n: 16);
  height: pixel-to-rem($n: 16);
  margin-right: pixel-to-rem($n: 6);
}

.header-tool {
  width: 100%;
  height: pixel-to-rem($n: 36);
  background-color: $background-black-color;

  .header-content {
    width: 1200px;
    font-size: pixel-to-rem($n: 12);
    color: $white-color;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .primary-button {
      background-color: $primary-color;
      color: $white-color;
      height: pixel-to-rem($n: 36);
      padding: 6px 20px;
      border: none;
      cursor: pointer;
    }

    .header-content-right {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .wechat {
        position: relative;
        cursor: pointer;
        margin-left: pixel-to-rem($n: 30);

        .icon {
          width: pixel-to-rem($n: 20);
        }

        &:hover .wechat-code {
          z-index: 999;
          top: calc(100% + 20px);
          opacity: 1;
        }

        .wechat-code {
          position: absolute;
          top: calc(100% + 50px);
          right: 0;
          padding: pixel-to-rem($n: 12);
          background-color: $white-color;
          z-index: -10;
          box-shadow: 0 2px 4px $info-third-color;
          opacity: 0;
          transition: all 0.3s ease-in-out;

          img {
            width: pixel-to-rem($n: 100);
            height: pixel-to-rem($n: 100);
          }
        }
      }
    }
  }
}
</style>
